import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import LabeledToggle from '../../shared/LabeledToggle';

import styles from './styles.scss';

const UncertaintyCalculation = ({ isEnable, description, onChange }) => [
  <Row key="content">
    <Col className={`py-3 px-0 mx-3 ${styles.infoSection}`}>
      <div className={styles.dataBlock}>
        <b>Uncertainty Calculation</b>
      </div>
      <div className={styles.dataBlock}>
        <p>{description}</p>
      </div>
      <div className={styles.dataBlock}>
        it will show along with the final result, as well as an explanation on the last page of the report. Some state
        templates require the Uncertainty Calculation to be present. On those templates, this Uncertainty Calculation
        will display regardless of this settings. For more information, see the support site
      </div>
      <div className={styles.toggle}>
        <LabeledToggle
          label="Enable Uncertainty Calculation for all Official Reports"
          checked={isEnable}
          onChange={() => onChange('uncertaintyCalculation', !isEnable)}
        />
      </div>
    </Col>
  </Row>,
];

UncertaintyCalculation.propTypes = {
  isEnable: PropTypes.bool,
  description: PropTypes.string,
  onChange: PropTypes.func,
};

export default UncertaintyCalculation;



// WEBPACK FOOTER //
// src/components/reportContentLayout/UncertaintyCalculation/index.jsx